import type { ForumTopic, ForumReply } from '@/mocks/forum';

export interface ForumTopicDbRow {
  id: string;
  owner_id: string;
  title: string;
  category: string | null;
  body: string | null;
  views: number | null;
  status: string | null;
  created_at: string | null;
}

export interface ForumReplyDbRow {
  id: string;
  topic_id: string;
  user_id: string;
  content: string | null;
  status: string | null;
  created_at: string | null;
}

export function mapDbForumTopic(
  row: ForumTopicDbRow,
  authorName: string,
  repliesCount: number,
): ForumTopic {
  return {
    id: row.id,
    ownerId: row.owner_id,
    authorName: authorName || 'Membre',
    title: row.title,
    category: row.category || 'Général',
    body: row.body || '',
    views: Number(row.views) || 0,
    repliesCount,
    createdAt: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}

export function mapDbForumReply(
  row: ForumReplyDbRow,
  authorName: string,
  authorInitials: string,
): ForumReply {
  return {
    id: row.id,
    topicId: row.topic_id,
    userId: row.user_id,
    authorName: authorName || 'Membre',
    authorInitials: authorInitials || '?',
    content: row.content || '',
    createdAt: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}

export function formatViews(views: number): string {
  if (views >= 1000) {
    const v = views / 1000;
    return `${v.toFixed(v >= 10 ? 0 : 1).replace('.', ',').replace(',0', '')}k vues`;
  }
  return `${views} vue${views > 1 ? 's' : ''}`;
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function timeAgo(dateStr: string): string {
  if (!dateStr) return '';
  const date = new Date(`${dateStr}T00:00:00`);
  const diff = Date.now() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days <= 0) return "aujourd'hui";
  if (days === 1) return 'hier';
  if (days < 30) return `il y a ${days} jours`;
  const months = Math.floor(days / 30);
  if (months === 1) return 'il y a 1 mois';
  if (months < 12) return `il y a ${months} mois`;
  const years = Math.floor(months / 12);
  return `il y a ${years} an${years > 1 ? 's' : ''}`;
}